module.exports = __webpack_public_path__ + "static/media/KimberleyEcho-socshare-min.e64f388c.jpg";